import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TabIndices } from '@/common/i-doc/i-doc.registry.ts';
import { PageHint } from '@components/common/PageHint.tsx';
import { FinanceLegacyOptions } from '@services/finance-legacy.service.ts';

// Довідник співробітників (entry_employes) - простий перелік, дані вже
// завантажені на рівні сторінки разом з рештою options, тут не дублюємо запит.
export const FinanceLegacyEmployeesTab: React.FC<{ options: FinanceLegacyOptions }> = ({ options }) => (
  <Box data-i-doc={TabIndices.DEV_FINANCE_LEGACY_EMPLOYEES}>
    <PageHint iDoc={TabIndices.DEV_FINANCE_LEGACY_EMPLOYEES} />

    {options.employees.length === 0 ? (
      <Typography sx={{ mt: 4, textAlign: 'center' }}>Співробітників не знайдено.</Typography>
    ) : (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Ім'я</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {options.employees.map((employee) => (
              <TableRow key={employee.value}>
                <TableCell>{employee.value}</TableCell>
                <TableCell>{employee.label}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>
);
